// src/App.js
import React from 'react';
import './App.css';
import MenuPage from './MenuPage';

function App() {
  return (
    <div className="App">
     
    </div>
  );
}

export default App;
